// extracted by mini-css-extract-plugin
export default {"balanceWrapper":"balanceWrapper---OIRIv","icon":"icon---ht5X_"};